import bonuses from './bonus/bonusIndex';
import { BonusState } from './bonus/bonusTypes';

export type PromotionHubState = {
    bonuses: BonusState;
};

export default {
    namespaced: true,
    modules: {
        bonuses,
    },
};
